// extracted by mini-css-extract-plugin
export default {"cls1":"RCg9X7BR4MrHBnojUMGM","cls2":"xs_oZqsFbkZ3ZRH7w6Xn RCg9X7BR4MrHBnojUMGM"};